// Client-side HTML helpers for the bulk email composer. The server re-sanitizes everything;
// these only make what the person sees (and sends) match what they expect.
import { sanitizeHtml } from "../components/RichTextEditor";

const URL_RE = /https?:\/\/[^\s<>"']+/g;

// Turn bare URLs typed into the editor into links (so they can be click-tracked),
// leaving existing links alone. Trailing punctuation stays outside the link.
export function autolinkHtml(html) {
  const doc = new DOMParser().parseFromString(`<body>${html || ""}</body>`, "text/html");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  const targets = [];
  for (let n = walker.nextNode(); n; n = walker.nextNode()) {
    if (!n.parentElement.closest("a") && URL_RE.test(n.nodeValue)) targets.push(n);
    URL_RE.lastIndex = 0;
  }
  targets.forEach((node) => {
    const frag = doc.createDocumentFragment();
    let last = 0;
    const text = node.nodeValue;
    text.replace(URL_RE, (m, idx) => {
      const trail = (m.match(/[.,;:!?)]+$/) || [""])[0];
      const url = trail ? m.slice(0, -trail.length) : m;
      frag.appendChild(doc.createTextNode(text.slice(last, idx)));
      const a = doc.createElement("a");
      a.setAttribute("href", url);
      a.textContent = url;
      frag.appendChild(a);
      last = idx + url.length;
      return m;
    });
    frag.appendChild(doc.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  });
  return doc.body.innerHTML;
}

const escHtml = (s) => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// What a recipient will see, with their merge fields filled in.
export function previewHtml(html, first, full) {
  return sanitizeHtml(
    (html || "").replace(/\{first_name\}/g, escHtml(first || "there")).replace(/\{full_name\}/g, escHtml(full || first || "there")),
  );
}
